import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../../api-spec";

@Component({
    selector: "app-task-update-task-data-api-manual",
    templateUrl: "../../../api-spec.html",
    styleUrls: ["../../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe],
})
export class TaskUpdateTaskDataApiManualV2Component extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Update Task",
            description:
                "This endpoint can be used to update an existing task. Note: updating a task will override all existing data for that task. This is only available for tasks that are currently not in status 'Done'",
            httpMethod: "POST",
            path: "/taskdata/v2/tasks/{guid}",

            parameters: [
                {
                    name: "guid",
                    description: "guid of the task to update",
                    in: "path",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "name",
                    description:
                        "new name of the task. (not available when task is in status 'Ready for review')",
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "new task name",
                },
                {
                    name: "description",
                    description: "new description of the task. (not available when task is in status 'Ready for review')",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "new task description",
                },
                {
                    name: "responsibles",
                    description:
                        "uuid's of the new users to be assigned as responsible to the task. (not available when task is in status 'Ready for review')",
                    in: "body",
                    paramType: "array",
                    required: true,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000000"
                    ]
                },
                {
                    name: "reviewers",
                    description: "uuid's of the new users to be assigned as reviewers to the task. (not available when task is in status 'Ready for review')",
                    in: "body",
                    paramType: "array",
                    required: false,
                    example: [
                        "00000000-0000-0000-0000-000000000000",
                        "00000000-0000-0000-0000-000000000000"
                    ]
                },
                {
                    name: "actionDate",
                    description: "the new action Date of the task. (not available when task is in status 'Ready for review')",
                    in: "body",
                    paramType: "date",
                    required: true,
                    example: "2021-07-21",
                },
                {
                    name: "comments",
                    description: "the new comments on the task",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "new comments on the task",
                },
                {
                    name: "score",
                    description: "ID of the score to set on the task. These can be retrieved with the Task Score direct data API",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "1",
                },
                {
                    name: "notifications",
                    description: `the new notifications for the task:
                                    -2: 3 months in advance
                                    -1: 2 months in advance
                                    1: 1 month in advance
                                    2: 3 weeks in advance
                                    3: 2 weeks in advance
                                    4: 1 week in advance
                                    5: 1 day in advance
                                    11: On due date
                                    6: 1 day in overdue
                                    7: 1 week in overdue
                                    8: 2 weeks in overdue
                                    9: 3 weeks in overdue
                                    10: 1 month in overdue
                                    12: 2 months in overdue
                                    13: 3 months in overdue
                                    (not available when task is in status 'Ready for review')`,
                    in: "body",
                    paramType: "array of integers",
                    required: false,
                    example: [4, 5, 11],
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                },
            ],
        };
    }
}
